import React from 'react';

export default function GuidanceScreen({ onContinue, onBack }) {
  return (
    <div className="view on" data-testid="guidance-screen">
      <h1>Before you begin</h1>
      <p className="desc">A quick overview of what to expect.</p>
      <div className="stack">
        <div className="guide-card" style={{ borderLeft: '4px solid var(--green)' }}>
          <div className="label green" style={{ marginBottom: '8px' }}>This is</div>
          <div className="dim">
            A reflective tool to understand your AI readiness across 12 dimensions. There are no right or wrong answers.
          </div>
        </div>
        <div className="guide-card" style={{ borderLeft: '4px solid var(--amber)' }}>
          <div className="label amber" style={{ marginBottom: '8px' }}>This is not</div>
          <div className="dim">
            A test or exam. Your responses help create a personalised development profile, not a score card.
          </div>
        </div>
      </div>
      <button className="btn btn-p" onClick={onContinue} data-testid="guidance-continue-btn">Continue</button>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
        <button className="text-link" onClick={onBack} data-testid="guidance-back-btn">&larr; Back</button>
      </div>
    </div>
  );
}
